import { render } from "./BtnBack.vue?vue&type=template&id=5f6b4d8e&scoped=true"
const script = {}

import "./BtnBack.vue?vue&type=style&index=0&id=5f6b4d8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6b4d8e"]])

export default __exports__